var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/cards/status/waiting"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1500211,8.53490705 L21.1520601,10.5369461 L20.2177648,11.4712415 L19.6838773,10.9373539 L19.2167453,11.404486 C21.5524679,13.5400047 22.0196,17.0101954 20.3512445,19.7463259 C18.4826538,22.9495884 14.3451273,23.9506079 11.208589,22.0152931 C8.07205065,20.0799782 7.07106239,16.0759001 8.93962177,12.8726375 C10.8081811,9.66937501 14.945739,8.66835547 18.1490015,10.6036703 L18.1490015,10.6036703 L18.7496132,10.0030586 L18.2157257,9.46920238 L19.1500211,8.53490705 Z M14.6787796,11.6046899 C12.0761288,11.6046899 10.0073655,13.6734844 10.0073655,16.2761352 C10.0073655,18.878786 12.0761288,20.9475493 14.6787796,20.9475493 C17.2814304,20.9475493 19.3501937,18.8787548 19.3501937,16.276104 L19.3501937,16.276104 L14.6787796,16.276104 Z M16.68085,7 L16.68085,8.33470314 L15.3461468,8.33470314 L15.3461468,9.00203908 C14.8789835,8.93531487 14.4785757,8.93531487 14.0114437,9.00203908 L14.0114437,9.00203908 L14.0114437,8.33470314 L12.6767405,8.33470314 L12.6767405,7 L16.68085,7 Z",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.db678299.svg";
export { ForwardRef as ReactComponent };